import React from 'react';
import { Link } from 'react-router-dom';
import MaterialIcon from '../MaterialIcon';

function FloatingActionBtn({ path, image }) {
	return (
		<Link to={path} className="floatingActionBtn">
			<MaterialIcon className={'floatingActionBtn__icon'}>{image}</MaterialIcon>
		</Link>
	);
}

export default FloatingActionBtn;
